import styled from '@emotion/styled';
import { Card, Drawer, Flex, Spin, theme } from 'antd';
import React, {
  createContext,
  type ReactElement,
  type ReactNode,
  Suspense,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useScreenWidth } from '../hooks/use-screen-width';
import { SiderContext } from '../layout';

const Collapsible = styled(Flex)`
  &:empty {
    max-width: 0;
  }
  & {
    align-items: flex-start;
    padding-inline-end: var(--ant-padding-md);
    flex: 1;
    transition: all 0.3s ease;
    overflow-y: auto;
  }
`;
const StyledDrawer = styled(Drawer)`
  & .ant-flex {
    padding-block: 0;
  }
  & {
    @media screen and (max-width: 769px) {
      .ant-btn {
        width: 100%;
      }
    }
  }
`;

const ExtraContentContext = createContext<{
  setContent: React.Dispatch<ReactNode | ReactNode[] | undefined>;
}>({
  setContent: () => {},
});

export const ExtraContentContextProvider = ({
  children,
}: {
  children: ReactElement;
}): ReactNode => {
  const { setSiderCollapsed } = useContext(SiderContext);
  const { token } = theme.useToken();
  const [content, setContent] = useState<ReactNode | ReactNode[] | undefined>(undefined);
  const isScreenLG = useScreenWidth('lg');

  useEffect(() => {
    content && setSiderCollapsed(true);
  }, [content]);

  return (
    <ExtraContentContext.Provider
      value={{
        setContent,
      }}
    >
      <Flex flex={1} style={{ height: '100%', overflowX: 'clip' }}>
        <Flex
          flex={1}
          style={{
            paddingInline: token.paddingMD,
            overflowY: 'auto',
            transition: 'all 0.3s ease',
          }}
        >
          {children}
        </Flex>
        {isScreenLG ? (
          <Collapsible>{content}</Collapsible>
        ) : (
          <StyledDrawer
            placement="bottom"
            onClose={() => {
              setContent(undefined);
            }}
            open={!!content}
            style={{
              borderStartStartRadius: token.borderRadiusLG,
              borderStartEndRadius: token.borderRadiusLG,
              maxHeight: '90vh',
            }}
            height="auto"
            styles={{
              body: { padding: 0 },
              mask: { backdropFilter: 'blur(1px)' },
              header: { display: 'none' },
            }}
          >
            {content}
          </StyledDrawer>
        )}
      </Flex>
    </ExtraContentContext.Provider>
  );
};

export const ExtraContent = ({
  children,
}: {
  children: ReactElement | undefined;
}): ReactElement[] => {
  const context = useContext(ExtraContentContext);
  // const contentKey = useRef<string>('');
  // const target = useRef(document.getElementById(EXTRA_CONTENT_PANEL_ID));

  // useEffect(() => {
  //   context.setCurrentContentKey(contentKey.current);
  // }, [children]);

  useEffect(() => {
    context.setContent(
      <Suspense
        fallback={
          <Card style={{ width: '100%' }}>
            <Flex style={{ height: 500 }} justify="center" align="center">
              <Spin />
            </Flex>
          </Card>
        }
      >
        {children}
      </Suspense>
    );
    return () => {
      context.setContent(undefined);
    };
  }, [children]);

  return [];
};
//
// export const ExtraContent = ({
//   children,
// }: {
//   children: ReactElement | undefined;
// }): ReactElement => {
//   return (
//     <Drawer
//       autoFocus={false}
//       open
//       closable={false}
//       destroyOnClose={true}
//       maskClosable={false}
//       mask={false}
//       getContainer={document.getElementById(EXTRA_CONTENT_PANEL_ID) ?? false}
//       rootStyle={{ position: 'absolute' }}
//       width="100%"
//       styles={{
//         wrapper: {
//           boxShadow: 'none',
//         },
//         content: {
//           backgroundColor: 'transparent',
//         },
//       }}
//     >
//       <Suspense
//         fallback={
//           <Card>
//             <Flex style={{ height: 500 }} justify="center" align="center">
//               <Spin />
//             </Flex>
//           </Card>
//         }
//       >
//         {children}
//       </Suspense>
//     </Drawer>
//   );
// };
